import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { Mr2 } from 'wrappers';
import { SecondaryTextSm400, Checkbox, Icon } from 'atoms';
import { CheckboxSvg, SendSvg } from 'components/icons';

const template = styled.div`
  display: flex;
  align-items: center;
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: wrap(Icon, Mr2),
      name: 'ToggleResidentNotifiedCheckbox',
      renderIf: ({ isActive }) => !isActive,
      displayValue: () => SendSvg({ vertical: true })
    },
    {
      component: wrap(Checkbox, Mr2),
      name: 'Checkbox',
      renderIf: ({ isActive }) => isActive,
      displayValue: ({ isSelected }) => CheckboxSvg({ checked: isSelected })
    },
    {
      component: SecondaryTextSm400,
      name: 'Text',
      displayValue: () => 'Resident will be notified'
    }
  ]
});
